import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {CommunicationContentModelSummaryConverter} from './communicationContentModelSummary.converter';
import {CommunicationContentModelModel} from '../communicationContentModel.model';

@Injectable()
export class CommunicationContentModelConverter extends HttpModelConverter<CommunicationContentModelModel> {

    constructor(private summaryConverter: CommunicationContentModelSummaryConverter) {
        super();
    }
    protected createInstance(): CommunicationContentModelModel {
        return new CommunicationContentModelModel();
    }

    protected enrichObject(result: CommunicationContentModelModel, src: CommunicationContentModelModel) {
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
